const Categories = [
  {
    key: "frontend",
    label: "Frontend",
    items: [
      { name: "Angular JS", icon: "fa-brands fa-angular" },
      { name: "React JS", icon: "fa-brands fa-react" },
      { name: "Vue JS", icon: "fa-brands fa-vuejs" },
      { name: "JavaScript", icon: "fa-brands fa-js" },
      { name: "CSS 3", icon: "fa-brands fa-css3-alt" },
      { name: "HTML 5", icon: "fa-brands fa-html5" },
    ],
  },
  {
    key: "backend",
    label: "Backend",
    items: [
      { name: ".NET", icon: "fa-solid fa-code" },
      { name: "PHP", icon: "fa-brands fa-php" },
      { name: "Ruby", icon: "fa-solid fa-gem" },
      { name: "Python", icon: "fa-brands fa-python" },
      { name: "JAVA", icon: "fa-brands fa-java" },
      { name: "NodeJS", icon: "fa-brands fa-node-js" },
      { name: "C Sharp", icon: "fa-solid fa-code" },
    ],
  },
  {
    key: "mobile",
    label: "Mobile",
    items: [
      { name: "Android", icon: "fa-brands fa-android" },
      { name: "iOS", icon: "fa-brands fa-apple" },
      { name: "Swift", icon: "fa-solid fa-code" },
      { name: "Flutter", icon: "fa-solid fa-mobile-screen" },
      { name: "Ionic", icon: "fa-brands fa-ionic" },
      { name: "React Native", icon: "fa-brands fa-react" },
      { name: "Xamarin", icon: "fa-solid fa-mobile" },
    ],
  },
  {
    key: "database",
    label: "Database",
    items: [
      { name: "SQL Server", icon: "fa-solid fa-database" },
      { name: "MySQL", icon: "fa-solid fa-database" },
      { name: "PostgreSQL", icon: "fa-solid fa-database" },
      { name: "MongoDB", icon: "fa-solid fa-leaf" },
      { name: "SQLite", icon: "fa-solid fa-database" },
      { name: "Firebase", icon: "fa-solid fa-fire" },
    ],
  },
  {
    key: "cloud",
    label: "Cloud",
    items: [
      { name: "Amazon Web Services", icon: "fa-brands fa-aws" },
      { name: "Google Cloud Platform", icon: "fa-brands fa-google" },
      { name: "Microsoft Azure", icon: "fa-brands fa-microsoft" },
    ],
  },
  {
    key: "devops",
    label: "DevOps",
    items: [
      { name: "Jenkins", icon: "fa-solid fa-gears" },
      { name: "Azure DevOps", icon: "fa-brands fa-microsoft" },
      { name: "Docker", icon: "fa-brands fa-docker" },
      { name: "Kubernetes", icon: "fa-solid fa-diagram-project" },
      { name: "AWS DevOps", icon: "fa-brands fa-aws" },
      { name: "Gradle", icon: "fa-solid fa-cubes" },
      { name: "GitHub Actions", icon: "fa-brands fa-github" },
      { name: "GitLab CI", icon: "fa-brands fa-gitlab" },
    ],
  },
  {
    key: "ecommerce",
    label: "Ecommerce",
    items: [
      { name: "WooCommerce", icon: "fa-brands fa-wordpress" },
      { name: "Magento 2", icon: "fa-solid fa-cart-shopping" },
      { name: "Shopify", icon: "fa-brands fa-shopify" },
      { name: "Kentico", icon: "fa-solid fa-bag-shopping" },
      { name: "Symfony", icon: "fa-brands fa-symfony" },
      { name: "Opencart", icon: "fa-solid fa-cart-shopping" },
      { name: "VirtueMart", icon: "fa-solid fa-store" },
      { name: "PrestaShop", icon: "fa-solid fa-store" },
      { name: "Bigcommerce", icon: "fa-solid fa-basket-shopping" },
      { name: "NopCommerce", icon: "fa-solid fa-bag-shopping" },
      { name: "ZenCart", icon: "fa-solid fa-cart-arrow-down" },
      { name: "Stripe", icon: "fa-brands fa-cc-stripe" },
    ],
  },
  {
    key: "crm",
    label: "CRM",
    items: [
      { name: "Microsoft Dynamics 365", icon: "fa-brands fa-microsoft" },
      { name: "Salesforce", icon: "fa-brands fa-salesforce" },
      { name: "Sugar CRM", icon: "fa-solid fa-cubes" },
      { name: "Hubspot", icon: "fa-brands fa-hubspot" },
      { name: "Zoho", icon: "fa-solid fa-diagram-project" },
    ],
  },
  {
    key: "cms",
    label: "CMS",
    items: [
      { name: "Drupal", icon: "fa-brands fa-drupal" },
      { name: "Wordpress", icon: "fa-brands fa-wordpress" },
      { name: "Joomla", icon: "fa-brands fa-joomla" },
      { name: "Sharepoint", icon: "fa-brands fa-microsoft" },
      { name: "Umbraco", icon: "fa-solid fa-u" },
      { name: "DNN", icon: "fa-solid fa-d" },
      { name: "Craft", icon: "fa-solid fa-c" },
    ],
  },
];

export const brandColors = {
  "Angular JS": "#dd1b16",
  "React JS": "#61dafb",
  "Vue JS": "#42b883",
  "JavaScript": "#f7df1e",
  "CSS 3": "#2965f1",
  "HTML 5": "#e34f26",
  ".NET": "#512bd4",
  PHP: "#777bb3",
  Ruby: "#cc342d",
  Python: "#3776ab",
  JAVA: "#f89820",
  NodeJS: "#68a063",
  "C Sharp": "#178600",
  Android: "#3DDC84",
  iOS: "#000000",
  Swift: "#F05138",
  Flutter: "#02569B",
  Ionic: "#3880ff",
  "React Native": "#61dafb",
  Xamarin: "#3498db",
  "SQL Server": "#a91d22",
  MySQL: "#00758f",
  PostgreSQL: "#336791",
  MongoDB: "#47a248",
  SQLite: "#0c6aa6",
  Firebase: "#ffca28",
  "Amazon Web Services": "#ff9900",
  "Google Cloud Platform": "#4285f4",
  "Microsoft Azure": "#0078d4",
  Jenkins: "#d33833",
  "Azure DevOps": "#0078d7",
  Docker: "#0db7ed",
  Kubernetes: "#326ce5",
  "AWS DevOps": "#ff9900",
  Gradle: "#02303a",
  "GitHub Actions": "#2088ff",
  "GitLab CI": "#fc6d26",
  WooCommerce: "#96588a",
  "Magento 2": "#f26322",
  Shopify: "#96bf48",
  Kentico: "#f15a22",
  Symfony: "#000000",
  Opencart: "#2caae1",
  VirtueMart: "#1a82c3",
  PrestaShop: "#df0067",
  Bigcommerce: "#0b1f2a",
  NopCommerce: "#2a99d6",
  ZenCart: "#c05b2b",
  Stripe: "#635bff",
  "Microsoft Dynamics 365": "#0078d4",
  Salesforce: "#00a1e0",
  "Sugar CRM": "#e6181f",
  Hubspot: "#ff7a59",
  Zoho: "#d42f2f",
  Drupal: "#0678be",
  Wordpress: "#21759b",
  Joomla: "#5091cd",
  Sharepoint: "#0078d4",
  Umbraco: "#3544b1",
  DNN: "#0085ca",
  Craft: "#e5422b",
};

export default Categories;